/* IntegrationDetailsModal.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _9 = "._jkue1j6v .ak-renderer-document, ._q7gq1j6v p{font-size:1rem}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTransition } from '@atlaskit/modal-dialog';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyNormal, Button, EditorRenderer, H4 } from '@atlassian/mpac-primitives';
import * as React from 'react';
import { TEST_ID } from '../../constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _8 = "._qwjmlxoi li{margin:0 0 var(--ds-space-050,4px) 0}";
const _7 = "._1x8w1vji{list-style-position:inside}";
const _6 = "._18s8vzgt{margin:var(--ds-space-250,20px) 0 0 0}";
const _5 = "._19bvidpf{padding-left:0}";
const _4 = "._n3tdidpf{padding-bottom:0}";
const _3 = "._u5f3idpf{padding-right:0}";
const _2 = "._ca0qidpf{padding-top:0}";
const _ = "._qtt81wth{list-style:disc}";
const ScopeList = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_qtt81wth _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _18s8vzgt _1x8w1vji _qwjmlxoi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ScopeList.displayName = 'ScopeList';
}
const RendererOverrides = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_jkue1j6v _q7gq1j6v", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RendererOverrides.displayName = 'RendererOverrides';
}
export const IntegrationDetailsModal = props => {
  const {
    enableAppificationChanges
  } = useStatsig();
  const {
    open,
    onClose,
    appName,
    permissionsJustification
  } = props;
  const atlassianAppText = enableAppificationChanges() ? 'app' : 'product';
  if (open) {
    var _props$appScopes;
    return /*#__PURE__*/_jsx(ModalTransition, {
      children: /*#__PURE__*/_jsxs(Modal, {
        onClose: onClose,
        testId: TEST_ID.OVERVIEW_TAB_INTEGRATION_DETAILS_MODAL,
        children: [/*#__PURE__*/_jsx(ModalHeader, {
          children: /*#__PURE__*/_jsx(H4, {
            as: "h1",
            children: "Integration details"
          })
        }), /*#__PURE__*/_jsx(ModalBody, {
          children: /*#__PURE__*/_jsxs(BodyNormal, {
            as: "div",
            children: [appName, " integrates with your Atlassian ", atlassianAppText, ". This remote service can:", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ScopeList, {
              children: (_props$appScopes = props.appScopes) === null || _props$appScopes === void 0 ? void 0 : _props$appScopes.map(scope => /*#__PURE__*/_jsx("li", {
                children: scope.capability
              }, scope.id))
            }), /*#__PURE__*/_jsx("br", {}), permissionsJustification && /*#__PURE__*/_jsxs(RendererOverrides, {
              children: [/*#__PURE__*/_jsx("p", {
                children: "Partner declared justification:"
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(EditorRenderer, {
                text: permissionsJustification
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(ModalFooter, {
          children: /*#__PURE__*/_jsx(Button, {
            appearance: "primary",
            onClick: onClose,
            children: "Got it"
          })
        })]
      })
    });
  }
  return null;
};